// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nb-0";
export var animationContainer = "_nb-1";
export var itemPrice = "_nb-a";
export var itemizedContent = "_nb-9";
export var itemizedHeader = "_nb-7";
export var itemizedRow = "_nb-8";
export var itemizedSection = "_nb-6";
export var modalContent = "_nb-2";
export var orderName = "_nb-3";
export var refundOption = "_nb-4";
export var refundOptionsContainer = "_nb-5";
export var shippingLabel = "_nb-b";
export var totalRow = "_nb-c";